import React from 'react';

class Header extends React.Component {
  render() {
    return (
      <div className="in-cart-item new">
        <div className="text-container">
          <h4>{this.props.quantity}X {this.props.title}</h4>
        </div>
      </div>
    )
    return (
      <div className="in-cart-item">
        <div className={`img-container ${this.props.type === 'pocket-big' ? 'pocket-big': ''}`}>
          <img src={this.props.imgSrc} alt={this.props.title} />
          <span className="quantity">{this.props.quantity}</span>
        </div>
        <div className="text-container">
          <h4>{this.props.title}</h4>
          <small>{this.props.variantTitle}</small>
        </div>
        <div className="price-container">
          <h4>{this.props.price}€</h4>
        </div>
      </div>
    );
  }
}

export default Header;